import { BodyText, LabelText } from "@classdojo/web/nessie";
import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import ShadowCard from "src/shared/components/ShadowCard";

type ConundrumCardProps = {
  mojo: string;
  href: string;
  title: string;
  description: ReactNode;
  duration: string;
};

export default function ConundrumCard({ href, mojo, title, description, duration }: ConundrumCardProps) {
  return (
    <ShadowCard sx={cardStyle}>
      <Link to={href}>
        <div sx={{ height: "100%", fontSize: 0 }}>
          <div sx={leftStyle}>
            <LabelText as="h3" sx={titleStyle}>
              {title}
            </LabelText>
            <BodyText level={2} kind="secondary">
              {description}
            </BodyText>
            <BodyText level={2} kind="tertiary" sx={durationStyle}>{`${duration} min activity`}</BodyText>
            <div sx={emojiStyle}>{"🌠 ⚖️ 💭"}</div>
          </div>
          <div
            sx={{
              height: "100%",
              maxWidth: "38%",
              overflow: "hidden",
              position: "relative",
              display: "inline-block",
              left: 11,
            }}
          >
            <img
              src={mojo}
              sx={{
                maxWidth: "100%",
                height: "215px",
                verticalAlign: "middle",
              }}
              alt="Conundrum image"
            />
          </div>
        </div>
      </Link>
    </ShadowCard>
  );
}

const cardStyle: ThemeUIStyleObject = {
  marginTop: "dt_m",
  overflow: "hidden",
  width: "100%",
  height: "215px",
  maxWidth: "500px",
};

const leftStyle: ThemeUIStyleObject = {
  textAlign: "left",
  display: "inline-block",
  padding: RAW_cssValue("16px"),
  width: "62%",
  lineHeight: "1.29",
  height: "100%",
  verticalAlign: "top",
};

const titleStyle: ThemeUIStyleObject = {
  marginBottom: "dt_s",
};

const emojiStyle: ThemeUIStyleObject = {
  marginTop: "dt_m",
  fontSize: "14px",
};

const durationStyle: ThemeUIStyleObject = {
  marginTop: "dt_xs",
};
